import * as protoHistory from "./proto/history";
import History = protoHistory.History;


/*                                                                                                 */
function createHistoryItem(historySearchItem: protoHistory.HistoryItem) {
  return protoHistory.HistoryItem.create({
    term: encodeURI(historySearchItem.term),
    date: historySearchItem.date
  })
}

/*                                                                                                 */
export function createHistory(items: protoHistory.HistoryItem[], currentTimestamp: number): History {
  const historyItems: protoHistory.HistoryItem[] = [];
  items.forEach((historyItem) => {
    historyItems.push(createHistoryItem(historyItem))
  })
  /*                                                                            */
  historyItems.sort((currentItem, nextItem) => {
    if (currentItem.date > nextItem.date) {
      return -1;
    } else if (currentItem.date < nextItem.date) {
      return 1;
    } else {
      return 0;
    }
  })
  return protoHistory.History.create({historyItems, currentTimestamp})
}

/*                                         */
export {protoHistory};
